/**
 * Challenge roll dispatcher.
 *
 * Each challenge version has an isolated roller under ./rollers/.
 * Historical rollers are frozen — never edit a live version's file.
 * Copy the latest roller forward when cutting a new version.
 *
 * Used by rollChallenge.js (browser) and script/verify_roll_digests.mjs (Node).
 */
import { roll as roll_v1_0_0 } from './rollers/v1_0_0.mjs';
import { roll as roll_v1_1_0 } from './rollers/v1_1_0.mjs';
import { roll as roll_v1_1_1 } from './rollers/v1_1_1.mjs';
import { roll as roll_v1_1_2 } from './rollers/v1_1_2.mjs';
import { roll as roll_v1_2_0 } from './rollers/v1_2_0.mjs';
import { roll as roll_v1_2_1 } from './rollers/v1_2_1.mjs';
import { roll as roll_v1_2_2 } from './rollers/v1_2_2.mjs';
import { roll as roll_v1_2_3 } from './rollers/v1_2_3.mjs';
import { roll as roll_v1_3_0 } from './rollers/v1_3_0.mjs';
import { roll as roll_v1_3_1 } from './rollers/v1_3_1.mjs';
import { roll as roll_v1_3_2 } from './rollers/v1_3_2.mjs';
import { roll as roll_v1_3_3 } from './rollers/v1_3_3.mjs';
import { roll as roll_v1_3_4 } from './rollers/v1_3_4.mjs';
import { roll as roll_v1_3_5 } from './rollers/v1_3_5.mjs';
import { roll as roll_v1_3_6 } from './rollers/v1_3_6.mjs';
import { roll as roll_v1_3_7 } from './rollers/v1_3_7.mjs';
import { roll as roll_v1_3_8 } from './rollers/v1_3_8.mjs';
import { roll as roll_v1_3_9 } from './rollers/v1_3_9.mjs';
import { roll as roll_v1_4_0 } from './rollers/v1_4_0.mjs';
import { roll as roll_v1_4_1 } from './rollers/v1_4_1.mjs';
import { roll as roll_v1_4_2 } from './rollers/v1_4_2.mjs';
import { roll as roll_v1_4_3 } from './rollers/v1_4_3.mjs';
import { roll as roll_v1_4_4 } from './rollers/v1_4_4.mjs';
import { roll as roll_v1_4_5 } from './rollers/v1_4_5.mjs';
import { roll as roll_v1_4_6 } from './rollers/v1_4_6.mjs';
import { roll as roll_v1_4_7 } from './rollers/v1_4_7.mjs';
import { roll as roll_v1_4_8 } from './rollers/v1_4_8.mjs';
import { roll as roll_v1_4_9 } from './rollers/v1_4_9.mjs';
import { roll as roll_v1_4_10 } from './rollers/v1_4_10.mjs';
import { roll as roll_v1_4_11 } from './rollers/v1_4_11.mjs';
import { roll as roll_v1_4_12 } from './rollers/v1_4_12.mjs';
import { roll as roll_v1_4_13 } from './rollers/v1_4_13.mjs';

const ROLLERS = {
  '1.0.0': roll_v1_0_0,
  '1.1.0': roll_v1_1_0,
  '1.1.1': roll_v1_1_1,
  '1.1.2': roll_v1_1_2,
  '1.2.0': roll_v1_2_0,
  '1.2.1': roll_v1_2_1,
  '1.2.2': roll_v1_2_2,
  '1.2.3': roll_v1_2_3,
  '1.3.0': roll_v1_3_0,
  '1.3.1': roll_v1_3_1,
  '1.3.2': roll_v1_3_2,
  '1.3.3': roll_v1_3_3,
  '1.3.4': roll_v1_3_4,
  '1.3.5': roll_v1_3_5,
  '1.3.6': roll_v1_3_6,
  '1.3.7': roll_v1_3_7,
  '1.3.8': roll_v1_3_8,
  '1.3.9': roll_v1_3_9,
  '1.4.0': roll_v1_4_0,
  '1.4.1': roll_v1_4_1,
  '1.4.2': roll_v1_4_2,
  '1.4.3': roll_v1_4_3,
  '1.4.4': roll_v1_4_4,
  '1.4.5': roll_v1_4_5,
  '1.4.6': roll_v1_4_6,
  '1.4.7': roll_v1_4_7,
  '1.4.8': roll_v1_4_8,
  '1.4.9': roll_v1_4_9,
  '1.4.10': roll_v1_4_10,
  '1.4.11': roll_v1_4_11,
  '1.4.12': roll_v1_4_12,
  '1.4.13': roll_v1_4_13,
};

/**
 * @param {string} version
 * @param {string} seed block.hash
 * @param {object} challengeConfigVersion version config object
 * @returns {{ version: string, mission: object, loadout: object, success: object }}
 */
export function rollMissionLoadout(version, seed, challengeConfigVersion) {
  const roller = ROLLERS[version];
  if (!roller) {
    throw new Error(`Unsupported challenge version: ${version}`);
  }
  return roller(seed, challengeConfigVersion);
}

export function getSupportedRollVersions() {
  return Object.keys(ROLLERS);
}
